import { SessionDto } from '@session/infra';
import { SessionDrillViewModel, SessionPlanRefViewModel, SessionViewModel } from '../models';
import { toSessionDrillViewModel } from './session-drill.view-model.mapper';

const MS_IN_SECOND: number = 1000;

export const toSessionViewModel = (dto: SessionDto): SessionViewModel => {
  const startedAt: Date = new Date(dto.startedAt);
  const endedAt: Date = new Date(dto.endedAt);
  const sessionDrills: readonly SessionDrillViewModel[] = dto.sessionDrills.map(toSessionDrillViewModel);
  const totalRuns: number =
    dto.totalRuns ?? sessionDrills.reduce((sum: number, sd: SessionDrillViewModel) => sum + sd.runs.length, 0);
  const durationSeconds: number =
    dto.durationSeconds ?? Math.max(0, Math.floor((endedAt.getTime() - startedAt.getTime()) / MS_IN_SECOND));
  const plan: SessionPlanRefViewModel | null =
    dto.plan === null || dto.plan === undefined
      ? null
      : { id: dto.plan.id, title: dto.plan.title, scheduledFor: dto.plan.scheduledFor };
  return {
    id: dto.id,
    startedAt,
    endedAt,
    durationSeconds,
    sessionDrills,
    totalRuns,
    plan
  };
};
